import('./pb-header.css');

const pbHeader = {
    init: () => {}
}

window.loadedComponents.push({ component: 'pb-header', init: pbHeader.init});

export default() => {
    pbHeader.init();
}